@use "../../../styles/breakpoint.module.scss" as *;

.singleCard {
    position: relative;
    display: grid;
    grid-column: content;
    grid-template-columns: subgrid;

    // Image Fill Variant
    &.imageFill {
        aspect-ratio: 2 / 1;
        height: 640px;

        @media ($below-mobile) {
            height: 480px;
        }

        .imageWrapper {
            position: absolute;
            inset: 0;
            z-index: 0;

            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
        }

        .contentWrapper {
            position: relative;
            z-index: 1;
            margin-top: auto;
            display: grid;
            grid-template-columns: subgrid;
            grid-template-rows: auto auto;
            grid-column: 1 / -1;
            align-items: flex-end;
            padding: var(--spacer-32);
            gap: var(--spacer-24);
            color: var(--white);
            background: linear-gradient(
                0deg,
                rgb(0 0 0 / 90%) 0%,
                rgb(0 0 0 / 0%) 100%
            );

            @media ($below-tablet) {
                grid-template-rows: auto auto auto;
                align-items: start;
                row-gap: var(--spacer-16);
            }
        }
    }

    // Image Block Variant
    &.imageBlock {
        .imageWrapper {
            grid-column: 1 / -1;
            grid-row: 1;
            aspect-ratio: 5 / 2;
            max-height: 560px;
            margin: auto;
            overflow: hidden;

            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
        }

        .contentWrapper {
            grid-column: 1 / -1;
            grid-row: 2;
            display: grid;
            grid-template-columns: subgrid;
            grid-template-rows: auto auto;
            padding: var(--spacer-40);
            gap: var(--spacer-24);
            color: var(--color-text);

            @media ($below-tablet) {
                grid-template-rows: auto auto auto;
                row-gap: var(--spacer-16);
            }
        }
    }
}

.headline {
    composes: fontHB80 from "../../../styles/typography.module.scss";
    grid-column: 1 / 6;
    grid-row: 1;

    @media ($below-tablet) {
        grid-column: 1 / -1;
        grid-row: 1;
    }

    .imageBlock & {
        color: var(--color-text);
        grid-column: 1 / 6;
        grid-row: 1;

        @media ($below-tablet) {
            grid-column: 1 / -1;
            grid-row: 1;
        }
    }
}

.body {
    composes: fontP20 from "../../../styles/typography.module.scss";
    grid-column: 6 / -1;
    grid-row: 1 / span 2;

    .singleCard:has(.stats) & {
        display: none;
    }

    @media ($below-tablet) {
        grid-column: 1 / -1;
        grid-row: 2;

        .singleCard:has(.stats) & {
            display: block;
        }
    }

    .imageFill & {
        padding-bottom: var(--spacer-24);

        @media ($below-tablet) {
            padding-bottom: 0;
        }
    }

    .imageBlock & {
        color: var(--color-text);
        grid-column: 6 / -1;
        grid-row: 1 / span 2;
        margin-top: auto;
        padding-bottom: var(--spacer-24);

        @media ($below-tablet) {
            grid-column: 1 / -1;
            grid-row: 2;
            padding-bottom: 0;

            .singleCard:has(.stats) & {
                display: block;
            }
        }
    }
}

.ctaWrapper {
    grid-column: 1 / 6;
    grid-row: 2;

    @media ($below-tablet) {
        grid-column: 1 / -1;
        grid-row: 3;
        margin-top: var(--spacer-8);
    }

    .imageBlock & {
        grid-column: 1 / 6;
        grid-row: 2;

        @media ($below-tablet) {
            grid-column: 1 / -1;
            grid-row: 3;
        }
    }
}

.stats {
    display: flex;
    gap: var(--spacer-24);
    grid-column: 6 / -1;
    grid-row: 1 / span 2;

    @media ($below-tablet) {
        display: none;
    }

    .imageBlock & {
        grid-column: 6 / -1;
        grid-row: 1 / span 2;

        @media ($below-tablet) {
            display: none;
        }
    }
}

.statItem {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: var(--spacer-8);
}

.statTitle {
    composes: fontHB64 from "../../../styles/typography.module.scss";
}

.statBody {
    composes: fontP16 from "../../../styles/typography.module.scss";
}

.singleCard:not(:has(.body)) {
    @media ($below-tablet) {
        .contentWrapper {
            grid-template-rows: auto auto;
            row-gap: var(--spacer-24);
        }

        .ctaWrapper {
            grid-row: 2;
            margin-top: 0;
        }
    }
}
